import { useEffect, useState } from 'react';

import { getWelcomePopup } from '../../../modules/communication';

import styled from 'styled-components';

import Dialog from '../Dialog';

const PopupImage = styled.img`
  width: 100%;
`;

const WelcomePopup = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState({});
  useEffect(() => {
    getWelcomePopup().then((response) => {
      if (response.data && response.data.success) {
        const communication = response.data.communication;
        if (!communication) {
          return;
        }
        setPopupData(communication);
        const lastDisplayedVersion = parseInt(localStorage.getItem('displayed-welcome-popup-id') || -1, 10);
        localStorage.setItem('displayed-welcome-popup-id', communication.id);
        setShowPopup(communication.id !== lastDisplayedVersion);
      }
    });
  }, []);

  const renderImage = () => (
    <PopupImage alt="welcome_popup_image" src={`/content/communications/${popupData.file_name}`}></PopupImage>
  );

  if (showPopup) {
    return (
      <Dialog
        isOpen={true}
        noPadding={true}
        closeCallback={() => {
          setShowPopup(false);
        }}
      >
        {popupData.link_url ? (
          <a href={popupData.link_url} target="_blank" rel="noreferrer">
            {renderImage()}
          </a>
        ) : (
          renderImage()
        )}
      </Dialog>
    );
  } else {
    return '';
  }
};

export default WelcomePopup;
